import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { AbstractGitQueryEntity, AbstractGitQueryEntityConfig } from '../git/state/abstract-git-query-entity.service';
import { AbstractFeatureChildUIModel } from '../models/abstract-feature.model';
import { AbstractGitEntityState } from '../models/abstract-git-entity-state.model';

export interface AbstractFeatureChildQueryEntityConfig<
  State extends AbstractGitEntityState = AbstractGitEntityState,
  UIModel extends AbstractFeatureChildUIModel = AbstractFeatureChildUIModel,
> extends AbstractGitQueryEntityConfig<State, UIModel> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentQuery: QueryEntity<any>;
}

export abstract class AbstractFeatureChildQueryEntity<
  State extends AbstractGitEntityState = AbstractGitEntityState,
  UIModel extends AbstractFeatureChildUIModel = AbstractFeatureChildUIModel,
> extends AbstractGitQueryEntity<State, UIModel> {
  constructor(protected readonly cfg: AbstractFeatureChildQueryEntityConfig<State, UIModel>) {
    super(cfg);
  }

  protected readonly parentQuery = this.cfg.parentQuery;

  abstract readonly active$: Observable<UIModel | undefined>;

  /**
   * The parent's active item's children mapped to UIModel objects.
   */
  abstract readonly activeItems$: Observable<UIModel[]>;
}
